import React from "react";
import PropTypes from "prop-types";

const TeamNameSettings = ({ teamName, setTeamName, t_controls }) => {
  return (
    <div className="md-form">
      <h5>{t_controls.team_name}</h5>
      <input
        className="form-control validate"
        type="text"
        value={teamName}
        placeholder={t_controls.team_name_placeholder}
        onChange={(e) => setTeamName(e.target.value)}
      />
    </div>
  );
};

TeamNameSettings.propTypes = {
  teamName: PropTypes.string.isRequired,
  setTeamName: PropTypes.func.isRequired,
  t_controls: PropTypes.object.isRequired,
};

export default TeamNameSettings;

